// extracted by mini-css-extract-plugin
export default {"modal_notification":"custommodal_modal_notification__pV9xG","modal_notification__visible":"custommodal_modal_notification__visible__P7L13"};